export default "__VITE_ASSET__CouTgKNk__"